<div class="card vh-80 mt-4">
    <div class="card-header">
        <!-- Navbar -->
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <div class="container-fluid">
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="nav navbar-nav">
                        <li class="nav-item">
                            <a class="nav-link" routerLink="./home" routerLinkActive="active">Profil</a>
                        </li>

                    </ul>
                </div>
            </div>
        </nav>
    </div>
    <div class="card-body">
        <div class="container-fluid">
            <div class="row vh-80">
                <!-- Right side for subcomponent -->
                <div class="col-md-12">
                    <!-- Use router-outlet to load subcomponent dynamically -->
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</div>